<div class="main-facet-wrapper">

  @if (displayFilterIcon()) {
    <div class="icon-wrapper">
      <button #presetMenuButton mat-icon-button [matMenuTriggerFor]="presetMenu"
              class="preset-menu-trigger"
              (mousedown)="clickStarted()" (mouseup)="clickEnded()" (mouseleave)="clickEnded()"
              [matTooltip]="tooltip() !== null ? tooltip() : ''"
              [matTooltipDisabled]="tooltip() === null">
        <mat-icon>bookmark</mat-icon>
      </button>
      <mat-menu #presetMenu="matMenu" class="preset-menu">
        <button mat-menu-item (click)="promptSavePreset()" [disabled]="selectedFacets().length === 0">
          <mat-icon>bookmark_add</mat-icon>
          <span>Save current filters</span>
        </button>
        <button mat-menu-item (click)="openPresetManager()">
          <mat-icon>tune</mat-icon>
          <span>Manage presets</span>
        </button>
        <mat-divider></mat-divider>
        @if (presetsForMenu().length > 0) {
          @for (preset of presetsForMenu(); track preset.id) {
            <button mat-menu-item (click)="applyPreset(preset)">
              <mat-icon>bookmark</mat-icon>
              <span>{{preset.name}}</span>
            </button>
          }
        } @else {
          <button mat-menu-item disabled>
            <mat-icon>bookmark_border</mat-icon>
            <span>No presets yet</span>
          </button>
        }
      </mat-menu>
    </div>
  }

  <div class="content-wrapper" [class.chip-scrollable]="chipRowScrollableEnabled()">
    <div class="chip-row">
      <div class="filter-input-container">
        <span class="flex-facet-autocomplete">

          <mat-icon class="add-icon" (click)="focus($event)">add</mat-icon>

          <input #filterInput [matChipInputFor]="chipList" class="filter-input" [placeholder]="placeholder()"
                 [matChipInputAddOnBlur]="false" [matAutocomplete]="auto"
                 (keydown.backspace)="$event.stopPropagation()"
                 (keydown.delete)="$event.stopPropagation()">

          @if (showFilterCountEnabled()) {
            <span class="filter-count-divider" aria-hidden="true"></span>
            <span class="filter-count">{{activeFilterCount()}}</span>
          }

          <mat-autocomplete #auto="matAutocomplete" class="mat-facet-autocomplete" (optionSelected)="autoCompleteSelected($event)"
                            [displayWith]="autoCompleteDisplay" panelWidth="250px">
            @for (facet of filteredFacets(); track facet.id) {
              <mat-option [value]="facet">
                @if (facet.icon) {
                  <mat-icon>{{facet.icon}}</mat-icon>
                }
                <span>{{ facet.label }}</span>
              </mat-option>
            }
          </mat-autocomplete>

        </span>
      </div>

      <div class="chip-scroll-container" #chipScrollContainer [class.has-scroll]="chipRowHasOverflow()">
        <mat-chip-grid #chipList>
          @for (facet of selectedFacetViews(); track facet.id) {
            <mat-chip-option @chipAnimation [color]="facet.readonly ? 'accent' : undefined"
                             class="facet-chip"
                             (selectionChange)="chipSelected($event, facet)" (click)="selectedFacetId.set(facet.id)"
                             [selected]="facet.id === selectedFacetId()"
                             matTooltip="{{facet.label + (facet.description ? ': ' + facet.description : '')}}"
                             matTooltipShowDelay="1000">
              <span class="flex-facet">

                @if (facet.icon) {
                  <mat-icon class="inline-chip-icon">{{facet.icon}}</mat-icon>
                }

                @if (chipLabelsEnabled()) {
                  <span>{{ facet.label + ': &nbsp;'}}</span>
                }

                @switch (facet.type) {
                  @case (FacetDataType.Category) {
                    {{facet.values | csv:'label':' / '}}
                  }
                  @case (FacetDataType.CategorySingle) {
                    {{facet.values | csv:'label':' / '}}
                  }
                  @case (FacetDataType.Typeahead) {
                    {{facet.values | csv:'label':' / '}}
                  }
                  @case (FacetDataType.TypeaheadSingle) {
                    {{facet.values | csv:'label':' / '}}
                  }
                  @case (FacetDataType.Date) {
                    “{{getDateValue(facet) | date:dateFormat()}}”
                  }
                  @case (FacetDataType.DateRange) {
                    “{{getDateValue(facet) | date:dateFormat()}}” ~ “{{getDateValue(facet, 1) | date:dateFormat()}}”
                  }
                  @case (FacetDataType.Boolean) {
                    <mat-checkbox [disabled]="true" class="inline-chip-checkbox" [ngModel]="getRawValue(facet)" (ngModelChange)="setValue(facet, $event)">
                      {{facet.label}}
                    </mat-checkbox>
                  }
                  @case (FacetDataType.Text) {
                    @switch (facet.filterType) {
                      @case (FacetFilterType.contains) {
                        “..{{getRawValue(facet)}}..”
                      }
                      @case (FacetFilterType.equal) {
                        “{{getRawValue(facet)}}”
                      }
                      @case (FacetFilterType.startsWith) {
                        “{{getRawValue(facet)}}...”
                      }
                      @case (FacetFilterType.endsWith) {
                        “...{{getRawValue(facet)}}”
                      }
                    }
                  }
                  @case (FacetDataType.Numeric) {
                    @switch (facet.filterType) {
                      @case (FacetFilterType.equal) {
                        “={{getRawValue(facet)}}”
                      }
                      @case (FacetFilterType.greaterThan) {
                        “>{{getRawValue(facet)}}”
                      }
                      @case (FacetFilterType.greaterThanOrEqual) {
                        “≥{{getRawValue(facet)}}”
                      }
                      @case (FacetFilterType.lessThan) {
                        “<{{getRawValue(facet)}}”
                      }
                      @case (FacetFilterType.lessThanOrEqual) {
                        “≤{{getRawValue(facet)}}”
                      }
                      @case (FacetFilterType.between) {
                        “{{getRawValue(facet)}} - {{getRawValue(facet, 1)}}”
                      }
                    }
                  }
                }

                @if (!facet.readonly) {
                  <mat-icon matChipRemove (click)="removeFacet(facet)">cancel</mat-icon>
                }

              </span>

            </mat-chip-option>
          }
        </mat-chip-grid>
      </div>
    </div>
  </div>


  @if (clearButtonEnabled() && selectedFacets().length > 0) {
    <button mat-flat-button (click)="reset()" color="accent" class="facet-clear-button">
      {{clearButtonText()}}
    </button>
  }

</div>
